import renderReliability from "@/components/tippy/Tippy";

const getRevenueReliability = (revenueReliability, translation, countryCode) => {
  switch (revenueReliability) {
    case "Modelled": {
      return renderReliability(
        translation(
          "companyProfile.overview.reliabilityDefinitionSalesModelled"
        ),
        translation("companyProfile.overview.modelled")
      );
    }
    case "Estimated": {
      if(["de", "ch", "at"].includes(countryCode)) {
        return renderReliability(
          translation("companyProfile.overview.reliabilityDefinitionSalesEstimatedRevenue"),
          translation("companyProfile.overview.estimated")
        );
      } else {
        return renderReliability(
          translation("companyProfile.overview.reliabilityDefinitionSalesEstimated"),
          translation("companyProfile.overview.estimated")
        );
      }
    }
    case "Actual": {
      if(["hu"].includes(countryCode)) {
        return renderReliability(
          translation("companyProfile.financial.reliabilityDefinitionSalesModelled"),
          translation("companyProfile.overview.actual")
        );
      } else {
      return renderReliability(
        translation("companyProfile.overview.reliabilityDefinitionSalesActual"),
        translation("companyProfile.overview.actual")
      );
    }
  }
    default: {
      return renderReliability(
        translation("companyProfile.overview.reliabilityDefinitionSalesActual"),
        translation("companyProfile.overview.actual")
      );
    }
  }
};

export default getRevenueReliability;
